// extracted by mini-css-extract-plugin
export default {"priceContainer":"Pia-z","discountedPrice":"Qia-z","originalPrice":"Ria-z","productPrice":"Sia-z"};